<template>
    <b-modal v-model="internalShow" @hide="$emit('update:show', false)" :title="$t('booking.attachInvoiceModal.title')">
        <div class="form-group">
            <label>
                {{ (isReturn) ? $t('booking.fields.invoiceReturn') : $t('booking.fields.invoice') }}
                <required-icon></required-icon>
            </label>
            <b-form-file v-model="data.invoice" :placeholder="$t('core.filePlaceholder')" multiple :browse-text="$t('core.chooseFiles')"></b-form-file>
            <small class="text-danger" v-if="errors['invoice']">{{ errors['invoice'][0] }}</small>
        </div>
        <template v-slot:modal-footer>
            <button class="btn btn-primary" @click="uploadInvoice">{{ $t('booking.attachInvoiceModal.upload') }}</button>
        </template>
    </b-modal>
</template>

<script>
import { BFormFile, BModal } from 'bootstrap-vue'
import { objectToFormData } from 'object-to-formdata'

export default {
    name: 'AttachInvoiceToBookingModal',
    components: { BModal, BFormFile },
    props: {
        show: {
            type: Boolean,
            default: false,
        },
        booking: {
            type: Object
        },
    },
    data: function () {
        return {
            isSubmitting: false,
            internalShow: false,
            errors: [],
            data: {
                invoice: null
            },
            isReturn: false
        }
    },
    watch: {
        show (val) {
            this.internalShow = val
            this.isReturn = this.booking.is_return;
            this.data.invoice = null
        },
    },
    methods: {
        uploadInvoice(){
            if(this.isSubmitting){
                return;
            }
            this.isSubmitting = true;
            const formData = objectToFormData(this.data);
            axios.post(`/bookings/${this.booking.id}/attach-invoice`, formData).then((response) => {
                this.internalShow = false;
                this.data.invoice = null;
                this.isSubmitting = false;
                this.$saveSuccess()
            }).catch((err) => {
                this.errors = err.response.data.errors
                this.isSubmitting = false;
            })
        }
    }
}
</script>
